import { LAYOUT_COLUMNS, LAYOUT_LIST, TEXT, LOGO } from '../items';
import { Translator } from '../Translator';
import { CardHelper } from './itemHelpers/CardHelper';
import { ItemOfType } from './itemHelpers/types';
import { translate } from './translate';

export const Quote5: Translator = sequence => {
  return translate(sequence, item => {
    switch (item.__typename) {
      case 'Card':
        return {
          id: item.id,
          type: LAYOUT_LIST,
          values: {
            align: 'center'
          },
          items: [
            CardHelper({} as ItemOfType<'Card'>, {
              width: '80vw',
              height: 'auto',
              clearStyles: 'sm',
              extraItems: [
                {
                  type: LAYOUT_COLUMNS,
                  id: '1',
                  values: {
                    // gridTemplateColumns: '1fr'
                  },
                  items: [
                    {
                      id: `${item.id}_list`,
                      type: LAYOUT_LIST,
                      values: {
                        align: 'center',
                        width: '100%'
                      },
                      items: [
                        {
                          type: LOGO,
                          id: `${item.id}_logo`,
                          items: [],
                          values: {}
                        },
                        {
                          type: TEXT,
                          id: `${item.id}_body`,
                          items: [],
                          values: {
                            value: item.body,
                            variant: 'heading2',
                            icon: 'cards',
                            quotes: true
                          }
                        }
                      ]
                    }
                  ]
                }
              ]
            })
          ]
        };
      default:
        return null;
    }
  });
};
